import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PortalAuthProvider, usePortalAuth } from './context/PortalAuthContext';
import PortalLogin from './pages/portal/PortalLogin';
import PortalSetup from './pages/portal/PortalSetup';
import PortalDashboard from './pages/portal/PortalDashboard';
import './theme.css';

// Capture a deep-link target (e.g. /portal?invoice=123) at load time, before an unauthenticated
// redirect to /portal/login can strip the query string. PortalDashboard consumes it after login.
try {
  const _p = new URLSearchParams(window.location.search);
  const _inv = _p.get('invoice');
  const _q = _p.get('quote');
  if (_inv) sessionStorage.setItem('fd_portal_deeplink', JSON.stringify({ tab: 'invoices', id: _inv }));
  else if (_q) sessionStorage.setItem('fd_portal_deeplink', JSON.stringify({ tab: 'quotes', id: _q }));
} catch { /* ignore */ }

function Routed() {
  const { status } = usePortalAuth();
  return (
    <Routes>
      <Route path="/portal/setup" element={<PortalSetup />} />
      <Route path="/portal/login" element={status === 'in' ? <Navigate to="/portal" replace /> : <PortalLogin />} />
      <Route
        path="/portal"
        element={
          status === 'loading' ? <div className="portal-loading">Loading…</div>
            : status === 'in' ? <PortalDashboard />
            : <Navigate to="/portal/login" replace />
        }
      />
      <Route path="*" element={<Navigate to="/portal" replace />} />
    </Routes>
  );
}

export default function PortalApp() {
  return (
    <PortalAuthProvider>
      <BrowserRouter>
        <Routed />
      </BrowserRouter>
    </PortalAuthProvider>
  );
}
